import home from './home/zh_CN'

export default {
  home,
  // 公共部份
  switchLanguage: "语言切换为中文",
  English: "English",
  data: "数据",
  // Dashboard
  logo: "智库决策支持系统",
  toAdmin: "管理后台",
  toOldVersion: "返回旧版",
  toHome: "平台官网",
  intoSystem: "进入系统",
  viewDetail: "查看详情",
  entrance: "快捷入口",
  summary: "信息概览",
  customSolution: "定制化解决方案",

  expiration_date_remaining: "有效期剩余",
  view: "查看",
  use_frequently: "经常使用",
  bingWechat: "绑定微信",
  bingWechatTips: "绑定微信后可扫码快捷登录",
  userCenter: "个人中心",
  panelSetting: "面板配置",
  theme: "主题设置",
  logout: "安全退出",
  homeTitle: "主页",
  doesNotSupport: "您的浏览器不支持 video 标签。",

  // 车型速览
  fastview: "车型速览",
  competitorCompare: "竞品对比",
  searchPlaceholder: "输入车型名称试试",
  searchEmpty: "没有搜到相关内容~",
  searchPlaceholder2: "搜索车型",
  latestNews: "最新动态",
  industryPolicy: "行业政策",
  effectiveDate: "实施日期",
  detailCompare: "详细对比",
  lifeCycle: "生命周期",

  // 用户中心
  switchAccount: "切换账号",
  collapseAccount: "收起账号",
  loginInfo: "登录信息",
  bindingDescription: "绑定后可使用手机号码、电子邮箱或微信扫码登录",
  mobileNo: "手机号码",
  email: "电子邮箱",
  wechat: "微信",
  wechatDescription: "微信扫一扫自动绑定",
  bind: "立即绑定",
  currentAccount: "当前账号",
  switchToThisAccount: "切换至该账号",
  expired: "已过期",

  // 绑定手机邮箱
  bindOrEdit: "绑定/修改",
  input: "请输入",
  vertifyCode: "验证码",
  get: "获取",
  confirm: "确定",
  cancel: "取消",
  mobileMessage: "请输入正确的手机号",
  emailMessage: "请输入正确的电子邮箱",
  vertifyMessage: "验证码输入错误，请重新输入",
  bindSuccess: "绑定成功",
  bindFail: "绑定失败",

  // 面板配置
  panelSettingTips: "搭配组建，打造您的专属控制台（最多可选3个）",
  selected: "已选",
  dragToAdjustSort: "拖动可调整排序",

  clickToApply: "申请试用",
  applyFormProduct: "申请试用产品",
  applyFormComfirm: "确定申请试用【{product}】吗？",

  // 菜单数据
  chimiLogoData: [
    {
      value: "智见OTA",
      label: "智见OTA",
      href: "https://iev.way-s.cn/ota"
    },
    {
      value: "智见分晓",
      label: "智见分晓",
      href: "https://iev.way-s.cn/intelligent"
    },
    {
      value: "智见权益",
      label: "智见权益",
      href: "https://iev.way-s.cn/promotion"
    },
    {
      value: "智见洞察",
      label: "智见洞察",
      href: "https://iev.way-s.cn/insight"
    }
  ],

  panels: {
    switchDataSource: "切换数据源",
    switchSegment: "切换细分市场",
    tableData: "表格数据",
    DATASOURCE_CLH_PIFA: "乘联会批发量",
    DATASOURCE_CLH_SALES: "乘联会销量",
    DATASOURCE_ZD_LINGSHOU: "终端零售量",
    VehicleMarket: "乘用车市场",
    NewEnergyMarket: "新能源市场",
    year: "年度",
    yoy: "同比",
    mom: "环比",
    rank: "排行",
    manf: "厂商",
    model: "车型",
    sales: "销量",
    salesYoy: "销量同比",
    salesMom: "销量环比",
    salesShare: "销量份额",
    shareYoy: "份额同比",
    msrp: "指导价",
    forePrice: "预售价",
    wan: "万",

    IndustryTrend: {
      title: "行业动向",
      more: "查看更多",
      news: "智见洞察",
      policy: "热点政策"
    },
    WholeMarketSales: {
      title: "销量"
    },
    ManfSalesRankTop10: {
      title: "厂商销量"
    },
    MarketPriceIndex: {
      title: "市场价格指数"
    },
    ModelSalesRankTop10: {
      title: "车型销量"
    },
    NewCarInfo: {
      title: "新车信息",
      onSale: "已上市",
      foreSale: "即将上市车型",
      have: "有",
      newCarOnSales: "款新车已上市",
      newCarForeSales: "款新车即将上市"
    }
  },
  filters: {
    level1: "一级",
    level2: "二级",
    level3: "三级",
    level4: "四级",
    thisProduct: "本品",
    competitiveCircle: "竞争圈",
    Favorites: "收藏夹",
    CustomFolder: "自定义文件夹",
    Select: "选择",
    competitorSet: "竞品设置",
    competitorCreate: "新建竞品组",
    competitorDelete: "确认要删除该竞品组？"
  },
  common: {
    tips: "提示",
    query: "查询",
    reset: "重置",
    create: "新建",
    edit: "编辑",
    cancel: "取消",
    save: "保存",
    confirm: "确认",
    action: "操作",
    delete: "删除",
    copy: "复制",
    NoData: "暂无数据",
    pin: "固定",
    unpin: "取消固定",
    total: "合计",
    totalItems: "共 {0} 条",
    rank: "排名",
    rankRange: "排名范围",
    trend: "趋势",
    vol: "销量",
    volYtd: "累计销量",
    gr: "增速",
    grYoy: "增速同比",
    grMom: "增速环比",
    grYtd: "累计增速",
    ms: "份额",
    msYoy: "份额同比",
    msMom: "份额环比",
    msYtd: "累计份额",
    msChange: "份额变化",
    msChangeYtd: "累计份额变化",
    change: "变化",
    dimension: "维度",
    dataSource: "数据源",
    datatime: "时间",
    dateTypeM: "月度",
    dateTypeQ: "季度",
    dateTypeY: "年度",
    fuelType: "燃料类型",
    manfType: "厂商属性",
    manfBrndType: "产地属性",
    luxuryType: "豪华类型",
    manf: "厂商",
    brand: "品牌",
    origin: "系别",
    submodel: "车型",
    submodelPerformance: "车型表现",
    segment: "细分市场",
    tier: "层级",
    region: "区域",
    manfBrand: "厂商品牌",
    regionCountryArea: "全国大区",
    regionCountryProvince: "全国省份",
    regionCountry: "全国",
    regionArea: "大区",
    regionProvince: "省份",
    regionCity: "城市",
    shareIndicator: "份额指标",
    shareIndicatorOpt: "所属 {0} 级细分市场",
    intersectionType: "交叉类型",
    analysisType: "分析类型",
    any: "不限",
    all: "整体",
    toTop: "置顶",
    selectPls: "请选择",
    maxMonthRange: "选择时间范围不超过 {0} 个月份",
    maxQuarterRange: "选择时间范围不超过 {0} 个季度",
    maxYearRange: "选择时间范围不超过 {0} 年",
    dataLabel: "数据标签",
    unit: "单位",
    dateRange: "时间范围",
    pastDateRange: "最近 {0} 年",
    allDateRange: "全部年份",
    indicator: "指标",
    chartTranspose: "行列互换",
    tableColSetting: "表格列设置",
    outOfRange: "超出范围",
    na: "无效值",
    compareManf: "厂商对比",
    compareBrand: "品牌对比",
    compareSubmodel: "车型对比",
    imported: "进口",
    domestic: "国产",
    cityLimtTyp: "限行限购类型",
    cityLimtTypOptions: [
      { value: "1", label: "限行限购" },
      { value: "2", label: "限行不限购" },
      { value: "3", label: "不限行限购" },
      { value: "4", label: "不限行不限购" }
    ]
  }
};
